import React from "react";
import styled from "styled-components";
import { EyebrowSm, Caption } from "storybook-components/Typography";
import NotchedImg from "../PostPreviewCards/NotchedImg";

const CardWrapper = styled.a`
  display: block;
  width: 100%;
  padding-top: 16px;
  text-decoration: none;
  color: unset;
  ${props => props.theme.media.desktopUp`
    padding-top: 16px;
    padding-left: 60px;
    
  `}
  &:hover {
    background-color: ${({ theme }) => theme.colors.green1};
  }
`;

const ContentWrapper = styled.div`
  border-bottom: ${({ theme }) => theme.colors.green1} solid 1px;
  ${props => props.theme.media.desktopUp`
    display: flex;
    padding-bottom: 16px;
  `}
`;

const StyledImage = styled(NotchedImg)`
  width: 120px;
  height: 120px;
  ${props => props.theme.media.desktopUp`
    width: 80px;
    height: 80px;
    margin: auto;
  `}
`;

const ContentColumn = styled.div`
  width: 320px;
  ${props => props.theme.media.desktopUp`
    width: 140px;
    margin-left: 12px;
  `}
`;

const StyledEyebrow = styled(EyebrowSm)`
  color: ${({ theme }) => theme.colors.green5};
  font-size: 1rem;
  ${props => props.theme.media.desktopUp`
    font-size: 0.6rem;
  `}
`;

const PostTitle = styled(Caption)`
  margin: 16px 0 24px;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.green5};
  ${props => props.theme.media.desktopUp`
    font-size: 0.75rem;
    margin: 0 0 16px;
  `};
`;

export default ({ title, contentType, contentImage, contentLinkUrl }) => (
  <CardWrapper href={contentLinkUrl}>
    <ContentWrapper>
      <StyledImage imageData={contentImage.gatsbyImageData} />
      <ContentColumn>
        <StyledEyebrow>{contentType}</StyledEyebrow>
        <PostTitle className="text">{title}</PostTitle>
      </ContentColumn>
    </ContentWrapper>
  </CardWrapper>
);
